import React, { Component } from 'react'
import { toJS } from 'mobx'
import chroma from 'chroma-js'
import { NavInExperience } from '../../components/nav'
import * as api from '../../lib/api'
import { Form } from '../../components/form'
import Loading from '../../components/loading'
import { Page } from '../'

// Couleur au format ARGB (#AARRGGBB) des thèmes, depuis une couleur RGB ou déjà ARGB.
const toArgb = color => chroma(color.length === 9 ? '#' + color.substr(3, 6) + color.substr(1, 2) : color).hex('argb')

export default class ExperienceTheme extends Component {
  state = {
    experience: {},
    loading: true,
    saving: false
  }

  populateState(experienceUid) {
    this.setState({ loading: true })

    if (experienceUid) {
      api.experiences.get(experienceUid).then(experience => {
        if (experience._id === this.props.match.params.experienceUid) {
          this.setState({ loading: false, experience })
        }
      })
    } else {
      this.setState({ loading: false })
    }
  }

  componentDidMount() {
    this.populateState(this.props.match.params.experienceUid)
  }

  save = formData => {
    const experienceUid = this.props.match.params.experienceUid
    formData.siteId = this.props.match.params.siteUid
    formData.colors = formData.colors || {}
    for (const key of ['color_primary', 'color_accent']) {
      if (formData.colors[key]) formData.colors[key] = toArgb(formData.colors[key])
    }

    return api.experiences.upsert({ _id: experienceUid, theme: formData }).then(experience => {
      this.setState({ experience })
    })
  }

  render() {
    const { match } = this.props
    const { experience, loading } = this.state
    const theme = toJS(experience.theme) || {}
    theme.colors = theme.colors || {}

    theme.colors.color_primary = theme.colors.color_primary || theme.colors.primary
    theme.colors.color_accent = theme.colors.color_accent || theme.colors.secondary
    return (
      <Page>
        {match.params.experienceUid && <NavInExperience />}
        <div id="content">
          {loading && <Loading />}
          {!loading && (
            <Form
              formPath="theme"
              initialFormData={theme}
              experienceUid={match.params.experienceUid}
              onDuplicate={this.duplicate}
              onDelete={this.delete}
              onSubmit={this.save}
              submitButtonText="Enregistrer"
            />
          )}
        </div>
        <div id="app-preview" />
      </Page>
    )
  }
}
